import { render, staticRenderFns } from "./ResourceSidePanel.vue?vue&type=template&id=50a711c9&"
import script from "./ResourceSidePanel.vue?vue&type=script&lang=ts&"
export * from "./ResourceSidePanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports